import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CustomerDecisionPage', {
    title: 'Customer Decision page',
    quoteInfo: 'Quote {quoteNumber} to {companyName}',
});
